import { useRef } from 'react';
import { THEMES, themeName } from '../lib/theme.js';
import { useOutsideClick } from '../hooks/useOutsideClick.js';
import { T } from './T.jsx';

function Swatch({ colors }) {
  return (
    <div className="theme-swatch">
      {colors.map((c) => (
        <span key={c} style={{ background: c }} />
      ))}
    </div>
  );
}

export function ThemeSwitcher({ theme, accentGradient, onChoose, open, onToggle, onClose }) {
  const toggleRef = useRef(null);
  const dropdownRef = useRef(null);

  useOutsideClick(open, [toggleRef, dropdownRef], onClose);

  return (
    <div className="theme-switcher">
      <button
        ref={toggleRef}
        className="theme-toggle-btn"
        aria-label="Change theme"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        <span
          className="theme-dot"
          style={{ background: accentGradient || 'linear-gradient(135deg,var(--accent-r),var(--accent-e))' }}
        />
        <span>{themeName(theme)}</span>
      </button>

      <div ref={dropdownRef} className={`theme-dropdown${open ? ' open' : ''}`}>
        {THEMES.map((t) => (
          <button
            key={t.id}
            className={`theme-option${t.id === theme ? ' active' : ''}`}
            data-theme={t.id}
            onClick={() => {
              onChoose(t.id);
              onClose();
            }}
          >
            <Swatch colors={t.swatch} />
            <div className="theme-option-info">
              <span className="theme-option-name">
                <T k={t.nameHash}>{t.name}</T>
              </span>
              <span className="theme-option-desc">
                <T k={t.descHash}>{t.desc}</T>
              </span>
            </div>
            <span className="theme-check">&#10003;</span>
          </button>
        ))}

        <div style={{ height: 1, background: 'var(--border)', margin: '6px 8px' }} />

        {/* Print lives in this menu because it is a rendering mode, not a theme:
            the print stylesheet is what actually produces the high-contrast output. */}
        <button
          className="theme-option"
          style={{ opacity: 0.7 }}
          onClick={() => {
            onClose();
            window.print();
          }}
        >
          <div className="theme-swatch" style={{ justifyContent: 'center', width: 30 }}>
            <span style={{ background: 'none', width: 'auto', height: 'auto', fontSize: '1.1rem' }}>
              &#128424;
            </span>
          </div>
          <div className="theme-option-info">
            <span className="theme-option-name">
              <T k="9b0db239785a19d6">Print / PDF</T>
            </span>
            <span className="theme-option-desc">
              <T k="28ef78825ff5bb7c">High-contrast, no animations</T>
            </span>
          </div>
          <span className="theme-check" style={{ opacity: 0 }}>
            &#10003;
          </span>
        </button>
      </div>
    </div>
  );
}
